/**
 * The heading block both reveal routes wear (DESIGN.md §3.6).
 *
 * `RevealScreen` and `JustificationScreen` render the same surface on purpose —
 * to the player the phase change between them is not an event, and the whole
 * point of that pair of files is that nobody can see it happen. So the heading
 * is written once here rather than twice there: a line that differed by a
 * hairline between the two would turn the server's phase change into a visible
 * jump, which is the one thing this screen is not allowed to do.
 *
 * The question leads. This is the phase where the room argues, and the argument
 * is about the question — but the screen used to name only its number while the
 * order being argued over scrolled underneath. `Screen` renders the heading
 * block `shrink-0` above the scrolling body, so the question stays on screen
 * with twelve rows passing under it.
 *
 * Set below heading size, the way the rank screen sets it, and for the same
 * reason: a full question at 28px runs to four lines and pushes the board off
 * the bottom of the phone.
 */
import type { Question } from '@idgame/protocol';

export function RevealHeading({
  question,
  isTurnPlayer,
  turnPlayerName,
}: {
  /** Null only on a phone that reconnected without one. */
  question: Question | null;
  isTurnPlayer: boolean;
  turnPlayerName: string;
}) {
  return (
    <>
      {question ? (
        <span
          data-testid="reveal-question"
          className="mb-2 block text-[0.875rem] leading-snug font-semibold text-ink-soft"
        >
          {question.number} · {question.text}
        </span>
      ) : null}
      <span className="block">
        {isTurnPlayer ? 'Explain your ranking.' : `${turnPlayerName} is explaining.`}
      </span>
    </>
  );
}
